import { Plugin } from '@ckeditor/ckeditor5-core/src';
import { Typing } from '@ckeditor/ckeditor5-typing/src';

/**
 * Converting <code> blocks without required by CKEditor <pre> block. Only needed for content created prior to CKEditor.
 */
export default class LegacyCode extends Plugin {

    /**
	 * @inheritDoc
	 */
	static get requires() {
		return [ Typing ];
	}

	/**
	 * @inheritDoc
	 */
	static get pluginName() {
		return 'LegacyCode';
	}

	/**
	 * @inheritDoc
	 */
	constructor( editor ) {
		super( editor );
	}

    /**
	 * @inheritDoc
	 */
    init() {
        // this.editor.conversion.for( 'upcast' ).elementToElement( {
		// 	model: ( viewElement, conversionApi ) => {

		// 		console.log(viewElement);
        //         if(viewElement.parent.name === 'pre') {
        //             return; // Already in CKEditor format
        //         }

		// 		conversionApi.consumable.consume( viewElement, { name: true } );

		// 		let codeBlock = conversionApi.writer.createElement( 'codeBlock' );
		// 		codeBlock._setAttribute('language', 'plaintext');

		// 		if (viewElement.childCount > 0) {
		// 			const position = conversionApi.writer.createPositionAfter(codeBlock, 0);
		// 			conversionApi.writer.insert(codeBlock, position);
		// 			return conversionApi.convertChildren(viewElement, position);
		// 		}
				

		// 		return codeBlock;
		// 	},
		// 	converterPriority: 'highest',
		// 	view: 'code'
		// } );

		this.editor.data.upcastDispatcher.on( 'element:code', ( evt, data, conversionApi ) => {
			//const { consumable, schema, writer } = conversionApi;
		
			if(data.viewItem.parent.name === 'pre') {
				return; // Already in CKEditor format
			}
		
			//conversionApi.consumable.consume( data.viewItem, { name: true } );

			let codeBlock = conversionApi.writer.createElement( 'codeBlock' );
			codeBlock._setAttribute('language', 'plaintext');

			//const position = conversionApi.writer.createPositionAfter(codeBlock, 0);
			//conversionApi.writer.insert(codeBlock, data.modelCursor);
			if ( !conversionApi.safeInsert( codeBlock, data.modelCursor ) ) {
				// When an element was not inserted, it means that you cannot insert a paragraph at this position.
				return;
			}

			conversionApi.consumable.consume(data.viewItem, { name: data.viewItem.name });

			// for ( const topLevelChild of data.viewItem.getChildren()) {
			// 	console.log(topLevelChild);
			// 	if( topLevelChild.is('element')) {
			// 		for(const child of topLevelChild.getChildren()) {
			// 			console.log(child);
			// 			if(child.is('text')) {
			// 				const text = conversionApi.writer.createText(child.data);	
			// 				conversionApi.writer.insert(conversionApi.writer.createPositionAt(topLevelChild, 0 ), text);
			// 			}
			// 		}
			// 	}
			// }

			// Convert the children to a paragraph.
			conversionApi.convertChildren(data.viewItem,  codeBlock);

			// Update `modelRange` and `modelCursor` in the `data` as a conversion result.
			conversionApi.updateConversionResult(codeBlock, data, conversionApi);
			

			// if (data.viewItem.childCount > 0) {
			// 	const position = conversionApi.writer.createPositionAfter(codeBlock, 0);
			// 	conversionApi.writer.insert(codeBlock, position);
			// 	return conversionApi.convertChildren(data.viewItem, position);
			// }  

			// const fontSize = data.viewItem.getStyle( 'font-size' );
		
			// // Do not go for the model element after data.modelCursor because it might happen
			// // that a single view element was converted to multiple model elements. Get all of them.
			// for ( const item of data.modelRange.getItems( { shallow: true } ) ) {
			// 	if ( schema.checkAttribute( item, 'fontSize' ) ) {
			// 		writer.setAttribute( 'fontSize', fontSize, item );
			// 	}
			// }
		}, { priority: 'highest' } );
    }
}